import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { usePopup } from '../../../../hooks/popup/usePopup';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

interface OpenMarketDetailPageFooterProps {
  children: JSX.Element;
}

export const OpenMarketDetailPageFooter = ({ children }: OpenMarketDetailPageFooterProps) => {
  const Popup = usePopup();

  const handleShareButtonClick = () => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'share', messageParam: window.location.href });
    } else {
      window.navigator.clipboard.writeText(window.location.href);
      Popup.toast('현재 게시물의 주소가 복사되었습니다.');
    }
  };

  return (
    <Container>
      <BlurSection />

      <ButtonContainer>
        <Button onClick={() => handleShareButtonClick()}>
          <Icon name={'Link'} width={16} height={16} />
        </Button>

        {children}
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 512px;
  min-height: 55px;

  display: flex;
  padding: 0px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 100px;
  align-self: stretch;

  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);

  background-color: #fff;
`;

const BlurSection = styled.div`
  width: 100%;
  max-width: 512px;
  height: 40px;

  display: flex;
  padding: var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  position: absolute;
  left: 0px;
  top: -40px;

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const Button = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: var(--radius-medium, 8px) 0px;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Monochrome-Grey10, #f3f4f5);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;
